<template lang="pug">
div(v-if="accommodation")
	v-card.mb-6(outlined)
		v-card-title.font-weight-bold Accommodatie + skipas
		v-list-item
			v-list-item-content(dense)
				v-list-item-title.body-1.font-weight-bold Aanbieder
			v-list-item-action
				v-img(:src="`${accommodation.partner.image}?width=120`" :width="60")
		v-list-item(two-line dense)
			v-list-item-content
				v-list-item-title.body-1.font-weight-bold Kamertype
				v-list-item-subtitle(style="white-space:normal") {{accommodation.name}}
		v-list-item(two-line dense)
			v-list-item-content
				v-list-item-title.body-1.font-weight-bold Aantal personen
				v-list-item-subtitle.flex-row.d-flex.justify-space-between
					span.d-flex volwassenen
					span.d-flex {{accommodation.persons}} personen
		v-list-item(two-line dense)
			v-list-item-content
				v-list-item-title.body-1.font-weight-bold Reisdata
				v-list-item-subtitle.flex-row.d-flex.justify-space-between
					span.d-flex {{$dayjs(accommodation.date).format('ddd D MMMM')}} - {{$dayjs(accommodation.date).add(accommodation.duration, 'days').format('ddd D MMMM')}}
					span.d-flex {{accommodation.duration}} nachten
		v-list-item(two-line dense)
			v-list-item-content(v-if="accommodation.skipas.included")
				v-list-item-title.body-1.font-weight-bold Skipas
				v-list-item-subtitle.flex-row.d-flex.justify-space-between
					span.d-flex {{accommodation.skipas.description}}
					span.d-flex.success--text inclusief
			v-list-item-content(v-else-if="skipas")
				v-list-item-title.body-1.font-weight-bold Skipas
				v-list-item-subtitle.flex-row.d-flex.justify-space-between
					span.d-flex {{skipas.name}}
					span.d-flex {{ $n(skipas.price, 'currency', $i18n.locale) }}
		v-divider.ma-3
		v-list-item.headline.font-weight-bold
			v-list-item-content
				v-list-item-title.accent--text Totaal
			v-list-item-action.accent--text {{ $n(totalPrice, 'currency', $i18n.locale) }}
	v-btn.mb-3(color="primary" depressed block :to="localePath({name: 'accommodations-checkout'})") » begin met accommodatie boeken
	.caption.text-center.grey--text Er wordt nog niets in rekening gebracht
</template>

<script>
export default {
	props: {
		accommodation: {
			type: Object,
			default: () => null
		},
		skipas: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {};
	},
	computed: {
		totalPrice() {
			let total = this.accommodation.price;

			if (this.skipas) {
				total += parseFloat(this.skipas.price);
			}

			return total;
		}
	}
};
</script>
